/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Subscription_Abonnement_In_BehandelingInputs */

const nl_app_subscription_abonnement_in_behandeling = /** @type {(inputs: App_Subscription_Abonnement_In_BehandelingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement in behandeling`)
};

/**

* @param {App_Subscription_Abonnement_In_BehandelingInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_subscription_abonnement_in_behandeling = /** @type {((inputs?: App_Subscription_Abonnement_In_BehandelingInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Subscription_Abonnement_In_BehandelingInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_subscription_abonnement_in_behandeling(inputs)
});
export { app_subscription_abonnement_in_behandeling as "app.subscription.abonnement_in_behandeling" }